
<mat-expansion-panel    #expander
                        *ngIf           =   "item && canAccess(item.authorized)"
                        class           =   "no-shadow my-2 pl-bgc" 
                        [ngClass]       =   "{'single-el': !hasChildren()}"
                        [hideToggle]    =   "!hasChildren()"
                        (click)         =   "clickItem(item)">

    <mat-expansion-panel-header expandedHeight="100%" collapsedHeight="100%" >

            <h6 #itemContainer
                class       =   "my-2 s-tc " 
                [ngStyle]   =   "{ 'margin-left': getOffset()}"  
                mat-line>            
                
                <mat-icon   *ngIf="item.icon"
                            class="align-middle unselectable"  
                            matListIcon>
                            {{item.icon}}
                </mat-icon>
                
                <span class="ml-2 align-middle unselectable" translate>
                    {{item.title}}
                </span>

            </h6>

    </mat-expansion-panel-header>

    <menu-item  *ngFor          =   "let child of item.children" 
                [item]          =   "child" 
                [level]         =   "level+1" 
                (clickOnItem)   =   "clickItem($event)"
                (openPanel)     =   "expand()"          ></menu-item>

</mat-expansion-panel>